import React, { useState } from 'react';
import styles from './BusinessFoundNotification.module.css';

const BusinessFoundNotification = () => {
  const [visible, setVisible] = useState(true);

  if (!visible) {return null;}

  const handleClose = () => {
    setVisible(false);
  };

  return (
    <div className={styles.container}>
      <div className={styles.accentBar} />

      <div className={styles.content}>
        <div className={styles.icon}>
          <div className={styles.iconLine} />
          <div className={styles.iconCircle} />
        </div>

        <div className={styles.message}>We have found your business</div>

        <div className={styles.closeButton} onClick={handleClose}>
          <div className={`${styles.closeLine} ${styles.closeLine1}`} />
          <div className={`${styles.closeLine} ${styles.closeLine2}`} />
        </div>
      </div>
    </div>
  );
};

export default BusinessFoundNotification;
